export const BankItem = (props: any) => {
  const { eachAccount, register, setValue } = props;
  // const {register,setValue}=useFormContext()
  return (
    <div key={eachAccount.accountNumber} className="bankRadio--row">
      <label
        className="radio__circle withOutline upi"
        onClick={() => setValue('creditType', 'bank')}
      >
        <input
          type="radio"
          {...register('creditTo')}
          value={eachAccount.accountNumber}
          id="DG_bank_radio"
        />
        <span className="radio__circle-checkmark"></span>
        <div className="radio__circle-label d-flex align-items-center">
          {/* <Image 
style={{ color: undefined }} 
          className="img-fluid"
          src={sbiLogo}
          alt="SBI logo"
          /> */}
          <div className="right">
            <p className="text--black text--bold title sell_p">
              {eachAccount.bankName} {eachAccount.accountNumber}
            </p>
            <p className="text--gray text--regular desc sell_p">
              {eachAccount.accountHolderName}
            </p>
          </div>
        </div>
      </label>
    </div>
  );
};
